module.exports = __webpack_public_path__ + "media/lucas.c20f8f37.mp3";